import React, { useState, useEffect, useRef } from "react";

function Workex({title, company, companyLink, dates, location, description}) {
    return (
        <div className="workex">
            <a href={companyLink} target="_blank" rel="noreferrer"> {company}</a>
            <div className="workex-header">
            <span className="workex-title"> {title}</span><span className="workex-dates">{dates}</span> 
            </div> 
            <div className="workex-data">
            <span className="workex-description">{description}</span><span className="workex-dates">{location}</span> 
            </div> 
        </div>
    );
}

export default Workex;